import React from 'react';
import { FadeIn } from '../ui/FadeIn';
import { BookOpen, Clock, MessageSquare, Wifi, HeartHandshake } from 'lucide-react';
export function DeliverablesSection() {
  const items = [{
    icon: <BookOpen className="w-6 h-6" data-id="element-19" />,
    title: 'El eBook Completo "El Código del Silencio"',
    desc: 'PDF de lectura rápida, directo al grano y sin relleno académico.'
  }, {
    icon: <Clock className="w-6 h-6" data-id="element-20" />,
    title: 'El Protocolo de los 4 Segundos',
    desc: 'La técnica exacta para detener cualquier explosión de ira antes de que escale.'
  }, {
    icon: <MessageSquare className="w-6 h-6" data-id="element-21" />,
    title: 'Diccionario de Gramática de Emergencia',
    desc: 'Frases de 3 palabras que cierran discusiones al instante y te devuelven el control.'
  }, {
    icon: <Wifi className="w-6 h-6" data-id="element-22" />,
    title: 'El Sistema de Negociación Invisible',
    desc: 'Cómo condicionar privilegios (Wi-Fi, salidas) sin negociar tu paz ni sonar como un dictador.'
  }, {
    icon: <HeartHandshake className="w-6 h-6" data-id="element-23" />,
    title: 'Guía de Supervivencia Emocional',
    desc: 'Qué hacer y cómo responder cuando te dice "Te odio" o "Eres la peor madre".'
  }];
  return <section className="py-24 px-4 bg-brand-slate border-y border-brand-charcoal" data-id="element-24">
      <div className="max-w-5xl mx-auto" data-id="element-25">
        <FadeIn data-id="element-26">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-16" data-id="element-27">
            Lo que obtienes hoy al acceder
          </h2>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8" data-id="element-28">
          {items.map((item, index) => <FadeIn key={index} delay={0.1 * index} className={index === 0 ? 'md:col-span-2' : ''} data-id="element-29">
              <div className={`
                h-full bg-brand-navy/40 border border-brand-charcoal p-8 rounded-2xl
                hover:border-brand-gold/30 transition-colors duration-300
                ${index === 0 ? 'flex flex-col md:flex-row items-center md:items-start gap-6 text-center md:text-left bg-gradient-to-br from-brand-navy/80 to-brand-navy/40' : 'flex flex-col items-start gap-4'}
              `} data-id="element-30">
                <div className="w-12 h-12 rounded-full bg-brand-gold/10 text-brand-gold flex items-center justify-center flex-shrink-0" data-id="element-31">
                  {item.icon}
                </div>
                <div data-id="element-32">
                  <h3 className="text-xl font-bold text-brand-cream mb-2" data-id="element-33">
                    {item.title}
                  </h3>
                  <p className="text-brand-gray" data-id="element-34">{item.desc}</p>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}